import { createContext } from "react";

interface IAppCtx {
    setErrorModal: () => void,
    setErrorModalMessage: (value: string) => void
}

export const AppContext = createContext<IAppCtx | null>(null)